export const beginCatalogListRequest = (state, action) => {
  state.latestListRequestId = action.meta?.requestId || "";
};

export const isLatestCatalogListRequest = (state, action) => (
  !action.meta?.requestId
  || !state.latestListRequestId
  || state.latestListRequestId === action.meta.requestId
);

